import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FullPageLoader, AllItemNavigateModal } from "..";
import { useExchangeFetch, useHardCode, useAPI } from "../../hooks";
import { ItemCard, Toast } from "../";
import { useAppContext } from "../../contexts";
import {
  updateExchangeSettingsDetails,
  updateSelectedProductDetails,
} from "../../redux/slices";
import {
  exchangeSettingsActionTypes,
  selectedProductActionTypes,
} from "../../redux/utils";
import { removeInsignificantZero, htmlColorPicker } from "../../Utilities";
import { CURRENCY_SYMBOLS } from "../../Utilities/currency";

export const Exchange = () => {
  const {
    colors,
    setColorID,
    setSelectedColor,
    colorID,
    sizes,
    setSizeID,
    setSelectedSize,
    sizeID,
    otherOptions,
    others,
    noVariantAvailable,
    setSelectedOthers,
    otherID,
    setOtherID,
    isExLoader,
    isOutOfStock,
    disableContinueButton,
    isActiveSquare,
    itemToBeReturnedTags,
    isInternalServerError,
  } = useExchangeFetch();
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const navigate = useNavigate();
  const {
    exchangeSearchInput,
    setexchangeSearchInput,
  } = useAppContext();
  const productDetailsState = useSelector((state) => state.productDetails);
  const exchangeSettingsState = useSelector((state) => state.exchangeSettings);
  const storeConfigState = useSelector((state) => state.storeSettings);
  const otherSettingsState = useSelector((state) => state.otherSettings);
  const selectedProductDetailsState = useSelector(
    (state) => state.selectedProductDetails
  );
  const [activeSquare, setActiveSquare] = useState(0);
  const old_item_name = exchangeSettingsState?.selectedProductName;
  const old_item_value =
    CURRENCY_SYMBOLS[exchangeSettingsState?.availableCreditCurrency] +
    removeInsignificantZero(parseFloat(exchangeSettingsState?.availableCredit));
  const dispatch = useDispatch();
  const old_item_variants = itemToBeReturnedTags
    ?.substring(0, itemToBeReturnedTags?.length - 1)
    .replace(/,/g, "/");
  const new_item_name = exchangeSettingsState?.newItemName;
  const new_item_value =
    CURRENCY_SYMBOLS[exchangeSettingsState.newItemPriceCurrency] +
    removeInsignificantZero(
      parseFloat(exchangeSettingsState.newItemPrice) *
        parseFloat(selectedProductDetailsState.selectedQuantity)
    );

  const new_item_color =
    exchangeSettingsState?.variantLabels?.[0] +
    (exchangeSettingsState?.newItemVariations?.tags.length > 0
      ? exchangeSettingsState?.newItemVariations?.tags?.[0]
      : "");
  const new_item_size =
    exchangeSettingsState?.variantLabels?.[1] +
    exchangeSettingsState?.newItemVariations?.tags?.[1];
  const new_item_other =
    exchangeSettingsState?.variantLabels?.[2] +
    exchangeSettingsState?.newItemVariations?.tags?.[2];
  let new_item_variants =
    (new_item_color ? new_item_color + "/ " : "") +
    (new_item_size ? new_item_size + "/ " : "") +
    (new_item_other ? new_item_other : "");
  new_item_variants = new_item_variants
    ?.replace(/\s+$/, "")
    ?.replace(/\/$/, "");
  const [isModalOpen, setModalIsOpen] = useState(false);
  const {
    EXCHANGE_ITEM_EXCHANGE_SESSION_API,
    EXCHANGE_ITEM_EXCHANGE_SESSION_PK_API,
  } = useAPI();
  const toggleModal = () => {
    setModalIsOpen(!isModalOpen);
  };

  const buttonHandler = () => {
    return !exchangeSettingsState.isImageUpload
      ? navigate("/ExchangePayment")
      : navigate("/photo");
  };

  const seeAllHandler = () => {
    setexchangeSearchInput("");
    exchangeSettingsState?.isAllowAllProducts
      ? toggleModal()
      : navigate("/OtherItems");
  };

  const backHandler = () => {
    /* it will navigate to the previous page */

    window.history.back();
  };

  const seeAll = async () => {
    try {
      const response = await axios.post(EXCHANGE_ITEM_EXCHANGE_SESSION_API, {
        store: storeConfigState?.storeUniqueID,
        state_data: {
          available_credit: exchangeSettingsState?.availableCredit,
          currency: productDetailsState?.currency,
          quantity: selectedProductDetailsState.selectedQuantity,
        },
      });
      toggleModal();
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_EXCHANGE_SESSION_PK,
          value: response.data.pk,
        })
      );

      const exchange_session_pk = response.data.pk;
      sessionStorage.setItem(
        "available_credit",
        exchangeSettingsState?.availableCredit
      );
      sessionStorage.setItem(
        "allowed_quantity",
        selectedProductDetailsState.selectedQuantity
      );
      sessionStorage.setItem("exchange_session_id", response.data.pk);
      let child = window.open(response.data.redirect_url, "_blank");

      let timer = setInterval(checkChild, 500);

      async function checkChild() {
        try {
          if (child.closed) {
            const response = await axios.get(
              `${EXCHANGE_ITEM_EXCHANGE_SESSION_PK_API}${exchange_session_pk}/`
            );
            clearInterval(timer);
            if (response?.data?.cart_data?.length > 0) {
              dispatch(
                updateSelectedProductDetails({
                  key: selectedProductActionTypes.SET_SHOPIFY_REDIRECTION,
                  value: true,
                })
              );
              dispatch(
                updateSelectedProductDetails({
                  key: selectedProductActionTypes.SET_SHOPIFY_SELECTED_PRODUCT_IMAGE,
                  value:
                    response?.data?.cart_data?.[0]?.featured_image?.url ||
                    "https://cdn.shopify.com/s/files/1/0757/9955/files/empty-state.svg",
                })
              );
              dispatch(
                updateExchangeSettingsDetails({
                  key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_PRICE,
                  value: removeInsignificantZero(
                    parseFloat(
                      response?.data?.cart_data?.[0]?.discounted_price / 100
                    )
                  ),
                })
              );
              dispatch(
                updateExchangeSettingsDetails({
                  key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_NAME,
                  value: response?.data?.cart_data?.[0]?.product_title,
                })
              );

              /* initialize the variation variable */
              let item_tags_with_value = "";

              let cartItemVariations =
                response?.data?.cart_data?.[0]?.options_with_values?.map(
                  (item) => {
                    if (item.name === "Title") {
                      return "";
                    }
                    return [
                      ...item_tags_with_value,
                      item.name + ":" + item.value + "/",
                    ];
                  }
                );
              dispatch(
                updateExchangeSettingsDetails({
                  key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_VARIANTS_SHOPIFY,
                  value: cartItemVariations
                    ?.toString()
                    ?.replace(/,/g, "")
                    .replace(/\/$/, ""),
                })
              );

              dispatch(
                updateExchangeSettingsDetails({
                  key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_QTY,
                  value: response?.data?.cart_data?.[0]?.quantity,
                })
              );
              dispatch(
                updateExchangeSettingsDetails({
                  key: exchangeSettingsActionTypes.UPDATE_EXCHANGE_VARIANT_ID,
                  value: response?.data?.cart_data?.[0]?.variant_id,
                })
              );

              dispatch(
                updateExchangeSettingsDetails({
                  key: exchangeSettingsActionTypes.UPDATE_EXCHANGE_PRODUCT_ID,
                  value: response?.data?.cart_data?.[0]?.product_id,
                })
              );

              buttonHandler();
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const activeSquareOption = (index) => {
    setActiveSquare(index);
  };
  useEffect(() => {
    /*Clearing All session storage */
    sessionStorage.clear();
  }, []);
  useEffect(() => {
    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_IS_EXCHANGE_OTHER,
        value: false,
      })
    );
    dispatch(
      updateSelectedProductDetails({
        key: selectedProductActionTypes.SET_SHOPIFY_REDIRECTION,
        value: false,
      })
    );
    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_VARIANTS_SHOPIFY,
        value: null,
      })
    );
  }, []);

  return (
    <>
      {isExLoader ? (
        <FullPageLoader />
      ) : (
        <main className="option choose exchange_main">
          {isInternalServerError && <Toast type="error" />}
          <div className="saara__container ">
            <div className="option__row">
              <div className="option__row-main">
                <div className="option__wrapper">
                  <div className="row__title mobile_hide">
                    <Link
                      to=""
                      onClick={backHandler}
                      className="btn__small_screen"
                    >
                      <img src="assets/svg/chevron_left.svg" alt="back" />
                    </Link>
                    <h1 className="option__title saara-title">
                      {
                        storeConfigState?.themeConfig
                          ?.exchange_product_detail_left_title
                      }
                    </h1>
                  </div>
                  <div className="option__panel">
                    <div className="option__subtitle__main">
                      <h2 className="option__subtitle">
                        {/*this key is undefined from backend storeConfigState?.themeConfig
                                      ?.exchange_product_detail_left_subtitle */}
                        {noVariantAvailable
                          ? `${
                              SHOPIFY_SHOP_OBJECT ===
                              CURRENT_STORE_NAME.pure_female
                                ? PURE_FEMALE_TRANSLATION.exchange_text
                                    .no_variant
                                : storeConfigState?.themeConfig
                                    ?.no_other_variant_message
                            }`
                          : `${
                              isOutOfStock
                                ? `${
                                    SHOPIFY_SHOP_OBJECT ===
                                    CURRENT_STORE_NAME.pure_female
                                      ? PURE_FEMALE_TRANSLATION.exchange_text
                                          .out_of_stock
                                      : storeConfigState?.themeConfig
                                          ?.errors_product_out_of_stock
                                  }`
                                : `${
                                    SHOPIFY_SHOP_OBJECT ===
                                    CURRENT_STORE_NAME.pure_female
                                      ? PURE_FEMALE_TRANSLATION.exchange_text
                                          .variant_subtitle
                                      : ""
                                  }`
                            }`}
                      </h2>
                      <h6 className="option__subtitle">
                        {exchangeSettingsState?.selectedProductName}
                      </h6>
                    </div>
                    <div className="variant_options">
                      {noVariantAvailable || (
                        <>
                          <div
                            className={`option__colors variant_options_content ${
                              exchangeSettingsState?.variantLabels?.[0] ||
                              "saara-d-none"
                            }`}
                          >
                            <span className="option__name">
                              {SHOPIFY_SHOP_OBJECT ===
                              CURRENT_STORE_NAME.pure_female
                                ? PURE_FEMALE_TRANSLATION.exchange_text.color
                                : exchangeSettingsState?.variantLabels?.[0]}
                            </span>
                            <div className="option__choise square_box_main">
                              {colors?.map((item, index) => {
                                return (
                                  <span
                                    key={index}
                                    onClick={() => {
                                      setColorID(index);
                                      setSelectedColor(item);
                                    }}
                                    className="square-box-space"
                                  >
                                    {isActiveSquare ? (
                                      <div
                                        className={`square-option ${
                                          activeSquare === index
                                            ? "square-active-option"
                                            : ""
                                        }`}
                                        onClick={() =>
                                          activeSquareOption(index)
                                        }
                                      >
                                        <div className="square-content">
                                          {htmlColorPicker(item).toUpperCase()}
                                        </div>
                                      </div>
                                    ) : (
                                      <div>
                                        <input
                                          type="radio"
                                          name="color"
                                          className="option__choise_radio"
                                          id={`color-${index}`}
                                          checked={index === colorID}
                                        />
                                        <label
                                          htmlFor={`color-${index}`}
                                          className="option__choise_label label__color"
                                          title={item}
                                        >
                                          <span
                                            className="option__choise_circle"
                                            data-color="#D94036"
                                            style={{
                                              background: htmlColorPicker(item),
                                            }}
                                          >
                                            <span
                                              className="option__choise_ring"
                                              style={{
                                                border: `2px solid ${htmlColorPicker(
                                                  item
                                                )}`,
                                              }}
                                            ></span>
                                          </span>
                                        </label>
                                      </div>
                                    )}
                                  </span>
                                );
                              })}
                            </div>
                          </div>
                          <div
                            className={`option__size variant_options_content ${
                              exchangeSettingsState?.variantLabels?.[1] ||
                              "saara-d-none"
                            }`}
                          >
                            <span className="option__name">
                              {SHOPIFY_SHOP_OBJECT ===
                              CURRENT_STORE_NAME.pure_female
                                ? PURE_FEMALE_TRANSLATION.exchange_text.size
                                : exchangeSettingsState?.variantLabels?.[1]}
                            </span>
                            <div className="option__choise">
                              {sizes?.map((item, index) => {
                                return (
                                  <span
                                    onClick={() => {
                                      setSizeID(index);
                                      setSelectedSize(item);
                                    }}
                                    key={index}
                                  >
                                    <input
                                      type="radio"
                                      name="size"
                                      className="option__choise_radio"
                                      id={`size-${index}`}
                                      checked={index === sizeID}
                                    />
                                    <label
                                      htmlFor={`size-${index}`}
                                      className="option__choise_label
                                          label__size"
                                    >
                                      <span className="option__choise_square">
                                        {item}
                                      </span>
                                    </label>
                                  </span>
                                );
                              })}
                            </div>
                          </div>
                          <div
                            className={`option__size variant_options_content ${
                              exchangeSettingsState?.variantLabels?.[2] ||
                              "saara-d-none"
                            }`}
                          >
                            <span className="option__name">
                              {exchangeSettingsState?.variantLabels?.[2]}
                            </span>
                            <div className="option__choise">
                              {others?.map((item, index) => {
                                return (
                                  <span
                                    onClick={() => {
                                      setOtherID(index);
                                      setSelectedOthers(item);
                                    }}
                                    key={index}
                                  >
                                    <input
                                      type="radio"
                                      name="other"
                                      className="option__choise_radio"
                                      id={`other-${index}`}
                                      checked={index === otherID}
                                    />
                                    <label
                                      htmlFor={`other-${index}`}
                                      className="option__choise_label
                                          label__size"
                                    >
                                      <span className="option__choise_square">
                                        {item}
                                      </span>
                                    </label>
                                  </span>
                                );
                              })}
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="option__items_content saara-d-none">
                      {otherOptions?.slice(0, 2).map((item) => {
                        return (
                          <div
                            key={item.variant_id}
                            className="option__items_card"
                          >
                            <div className="option__items_picture">
                              <img
                                src={item.img_url}
                                alt=""
                                className="option__items_img"
                              />
                            </div>
                            <div className="option__items_info">
                              <h3 className="option__items_title">
                                {item.name}
                              </h3>
                              <div className="option__price">
                                <span className="option__price_new">
                                  {productDetailsState?.currency}
                                  {item.price}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <button
                      type="button"
                      className="saara__btn
                                  btn__continue saara-d-none"
                      id="other-btn"
                      onClick={seeAll}
                    >
                      {
                        storeConfigState?.themeConfig
                          ?.exchange_product_detail_see_all_button_label
                      }
                    </button>
                  </div>
                </div>
                <div className="option__right">
                  <div className="item_card_main item_card_exchange">
                    <ItemCard
                      label={
                        SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female
                          ? PURE_FEMALE_TRANSLATION.exchange_text.old
                          : storeConfigState?.themeConfig
                              ?.exchange_review_old_product_tag_label
                      }
                      imageSrc={
                        selectedProductDetailsState?.selectedProductImage ||
                        otherSettingsState.defaultImage
                      }
                      value={`${
                        SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female
                          ? PURE_FEMALE_TRANSLATION.exchange_text.exchange_value
                          : storeConfigState?.themeConfig
                              ?.exchange_product_detail_right_card_title
                      }: ${old_item_value}`}
                      name={old_item_name}
                      variants={old_item_variants}
                      labelClass="old_item_label"
                    />
                    <ItemCard
                      label={
                        SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female
                          ? PURE_FEMALE_TRANSLATION.exchange_text.new
                          : storeConfigState?.themeConfig
                              ?.exchange_review_new_product_tag_label
                      }
                      imageSrc={
                        selectedProductDetailsState.shopifyRedirection
                          ? selectedProductDetailsState.shopifySelectedProductImage
                          : exchangeSettingsState?.newItemVariations?.img_url
                      }
                      value={
                        selectedProductDetailsState.shopifyRedirection
                          ? `Price:${new_item_value}`
                          : `${
                              SHOPIFY_SHOP_OBJECT ===
                              CURRENT_STORE_NAME.pure_female
                                ? PURE_FEMALE_TRANSLATION.exchange_text
                                    .exchange_value
                                : storeConfigState?.themeConfig
                                    ?.exchange_review_item_value_label
                            }: ${new_item_value} `
                      }
                      name={new_item_name}
                      itemQty={exchangeSettingsState.newItemQty}
                      variants={
                        selectedProductDetailsState.shopifyRedirection
                          ? exchangeSettingsState.newItemVariantsShopify
                          : new_item_variants
                      }
                      labelClass="new_item_label"
                      redirectedFromShopify={
                        selectedProductDetailsState.shopifyRedirection
                      }
                    />
                    {disableContinueButton && (
                      <span className="info__error error-items exchange-out-of-stock">
                        {SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female
                          ? PURE_FEMALE_TRANSLATION.exchange_text.out_of_stock
                          : storeConfigState?.themeConfig
                              ?.errors_product_out_of_stock}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="btn-width-100 exchange-btn-main exchange-btns">
                <div
                  className={`see-all-container ${
                    otherOptions?.length > 0 ? "" : "hide_see_all"
                  }`}
                >
                  <div className="mobile-center">
                    <button
                      className=" saara__btn   back_page
                      btn_all_items "
                      onClick={seeAllHandler}
                      disabled={otherOptions?.length > 0 ? false : true}
                    >
                      {
                        storeConfigState?.themeConfig
                          ?.exchange_product_detail_see_all_button_label
                      }
                    </button>
                  </div>
                </div>

                <div className="mobile-back">
                  <div className="saara-flex">
                    <button
                      className="saara_custom_btn saara__btn btn__back back_page btn__big_screen margin-right-20 btn-back-big-device"
                      onClick={backHandler}
                    >
                      {storeConfigState?.themeConfig?.back_button_label}
                    </button>
                    <button
                      className={`saara_custom_btn form__btn btn-continue-big-device exchange-continue ${
                        disableContinueButton && "form__btn__disabled"
                      }`}
                      onClick={buttonHandler}
                      disabled={disableContinueButton}
                    >
                      {storeConfigState?.themeConfig?.continue_button_label}
                    </button>
                  </div>
                </div>
              </div>

              <div className="row__title mobile_show exchange-option-heading">
                <Link to="" onClick={backHandler} className="btn__small_screen">
                  <img src="assets/svg/chevron_left.svg" alt="back" />
                </Link>
                <h1 className="option__title saara-title">
                  {" "}
                  {
                    storeConfigState?.themeConfig
                      ?.exchange_product_detail_left_title
                  }
                </h1>
              </div>
            </div>
          </div>
          {isModalOpen && (
            <div className="saara-modal-backdrop">
              <AllItemNavigateModal
                onRequestClose={toggleModal}
                otherItems={seeAll}
              />
            </div>
          )}
        </main>
      )}
    </>
  );
};
